<template>
  <div>
    <TopBar></TopBar>

    <el-main style="height: auto">
      <div style="height: 50px;"><b class="mc">课程名称：{{resource.chapter_title}}</b></div>
      <div style="width: 1280px;height: 530px;margin:0 auto;">
        <!--播放器-->
        <div style="width: 68%;float: left;height: 530px;">
<!--          <video width="100%" height="100%" controls :src="resource.chapter_src" type="video/mp4" @timeupdate="updateTime" @canplay="getDuration">-->
            <video @timeupdate="updateTime" @canplay="getDuration" ref="video" :src="resource.chapter_src" controls="controls" autoplay="autoplay" width="100%" height="100%">
          </video>
        </div>

        <!--章节栏-->
        <div style="width:32%;height: 100%;float: right;">
          <el-card style="width:100%;height: 100%;float: right;">
            <div style="text-align:left;margin-top: 5px;height: 35px">
              <ul class="biao">
                <li class="duih"><a>对话 工橙院Ai</a></li>
                <li class="zaix" @click="openNote()"><a>在线编程</a></li>
              </ul>
            </div>
            <div style="text-align:left;margin-top: 5px;height: 400px;overflow: auto;font-size: 14px;overflow-y: auto;">
              <div  id="bigBox">
                <div
                    v-for="(item, index) in list"
                    class="msgCss"
                    :style="{textAlign: item.align}"
                >
            <span v-if="item && item.align == 'left'">
              <span v-if="item && item.link == ''">{{item.text}}</span>
              <span v-if="item && item.link"
              >: <a :href="item.link" target="_blank">{{item.text}}</a></span
              >
            </span>
                  <div class="chatrg">
                     <span v-if="item && item.align == 'right'">
                      <div class="huid" >
                        <a style="float: right;color: darkorange">提问时间</a>
                        <a>{{item.timestamp}}</a>&nbsp;&nbsp;&nbsp;&nbsp;

                      </div>
                       <a>{{item.text}}</a>
                     </span>

                  </div>

                </div>
              </div>

            </div>
            <div style="text-align:left;margin-top: 5px;height: 45px;overflow: auto;">

                <el-input
                    placeholder="请输入内容" type="textarea"
                    v-model="input3"
                    class="input-with-select"
                    :autofocus="true"
                    ref="serachBox"
                    @keyup.enter.native="handleEnterKey" style="width: 60%;height:39px"
                >

                </el-input>
                <el-button
                        :loading="loading"
                        @keydown.enter.native="handleMsg"
                        slot="append"
                        type="primary"
                        @click="handleMsg" style="background-color: #FFAE00;"
                >发送</el-button>

              <el-button :loading="loading" slot="append" style="background-color: #FFAE00;"
                         id="startRecognizeOnceAsyncButton"
                         @click="startRecognize()"
              >
                  <span v-if="isListening" style="color:#fff">识别中...</span><span v-else>语音</span>
              </el-button>
<!--                <el-card header="语音转文字">-->
<!--                    <el-card>-->
<!--                        <el-input :readonly="true" id="word" v-model="word"></el-input>-->
<!--                    </el-card>-->
<!--                </el-card>-->
            </div>
            <!--  添加笔记弹窗组件  -->
            <note :visible.sync="visible"></note>
          </el-card>
        </div>
      </div>
      <br>  <br>

        <!--  下半部分  -->
      <div style="width: 1200px;height: 100%;background-color: white;margin:0 auto">
        <!--  分割线  -->
        <el-divider></el-divider>

      </div>
    </el-main>

    <el-backtop :bottom="80">Top</el-backtop>

    <FootBar></FootBar>
  </div>
</template>
<script src="https://aka.ms/csspeech/jsbrowserpackageraw"></script>
<script src="https://cdn.jsdelivr.net/npm/microsoft-cognitiveservices-speech-sdk@latest/distrib/browser/microsoft.cognitiveservices.speech.sdk.bundle-min.js">
</script>
<script src="https://webrtc.github.io/adapter/adapter-latest.js"></script>
<script>
import TopBar from "../layout/TopBar";
import FootBar from "../layout/FootBar";
import Note from "../Dialog/Note";
import Comment from "./Comment";
import {videoPlayer} from 'vue-video-player';
import 'video.js/dist/video-js.css';
import 'vue-video-player/src/custom-theme.css';
import jwt from 'jsonwebtoken';
import Recorder from 'js-audio-recorder';
import { Message } from "element-ui";
import axios from 'axios';
import * as sdk from "microsoft-cognitiveservices-speech-sdk";
//import * as fs from "fs";

import  SpeechSDK  from './speechsdk/microsoft.cognitiveservices.speech.sdk.bundle.js'

export default {
  name: "Player",
  components: {
    TopBar,
    FootBar, Comment,
    videoPlayer,
    Note
  },
  data() {
    return {
      uid: jwt.decode(sessionStorage.getItem('token')).uid,
      username: jwt.decode(sessionStorage.getItem('token')).username,
      visible: false,
      resource: '',
      hotCourse: '',
      chapterList: '',
      noteDialogShow: false,
      chapter_id: this.$route.params.chapter_id,
      course_id: this.$route.params.course_id,
      recorderDialogVisible: false,
      rec: null,
      recordBase64: '',
      flag: false, // false 代表还没开始录音
      audioUrl: '',
      isListening: false, // 判断是否在语音监听中
      recorder: new Recorder({
        sampleBits: 16, // 采样位数，支持 8 或 16，默认是16
        sampleRate: 16000, // 采样率，支持 11025、16000、22050、24000、44100、48000，根据浏览器默认值，我的chrome是48000
        numChannels: 1, // 声道，支持 1 或 2， 默认是1
        // compiling: false,(0.x版本中生效,1.x增加中)  // 是否边录边转换，默认是false
      }),
      mediaStream: null,
      audioContext: null,
      sourceNode: null,
      recording: false,
      timestamp:'',
      chat_history:'',
      visible1: false,
      input3: "",//提问的问题
        word: "",//返回的chat
      list: [],
      loading: false,
        gptlist:[],//用来存放gpt的全部返回记录
        word: "",//tts识别字段
    }
  },

  created() {
    this.getCourseSrc(this.course_id, this.chapter_id)
    this.getChapterList(this.course_id)
    this.getHotCourses()
    this.flag = false
    this.getChatGPT()
  },

    async mounted() {
         try {
           // 请求麦克风访问权限
           this.mediaStream = await navigator.mediaDevices.getUserMedia({ audio: true })

           // 初始化 AudioContext 和 MediaStreamSource 对象
           this.audioContext = new (window.AudioContext || window.webkitAudioContext)()
           this.sourceNode = this.audioContext.createMediaStreamSource(this.mediaStream)

           // 创建录音对象并初始化
           this.recorder = new Recorder(this.sourceNode.context, { numChannels: 1 })
//           await this.recorder.init()
         } catch (error) {
           console.log(error.message)
         }

    },
  methods: {
      audioCHangeWord() {
          var that = this;
          that.word = "";
          // 创建SpeechRecognition对象
          // eslint-disable-next-line no-undef
          var recognition = new webkitSpeechRecognition();
          console.log("recognition1", recognition);
          if (!recognition) {
              // eslint-disable-next-line no-undef
              recognition = new SpeechRecognition();
          }
          console.log("recognition2", recognition);
          // 设置语言
          recognition.lang = 'zh-CN';
          // 开始语音识别
          recognition.start();
          that.isListening = true;
          // 监听识别结果
          recognition.onresult = function (event) {
              var result = event.results[0][0].transcript;
              console.log("2监听结果:", result);
              that.word = result;
          };

          // 监听错误事件
          recognition.onerror = function (event) {
              that.isListening = false;
              console.log("2监听语音失败:"+event.error);
          };
          // 监听结束事件（包括识别成功、识别错误和用户停止）
          recognition.onend = function () {
              that.isListening = false;
              console.log("2语音识别停止");
          };

      },
    startRecognize(){
//        this.audioCHangeWord();
//        return;
        var resultsDivs;
        var startRecognizeOnceAsyncButton;
//        var subscriptionKey = "ca5e53cbad144a64afcf6ba21f33a2c3";
        var subscriptionKey = "53d3059b7a5e4180a235901f5b528126";
        var serviceRegion = "westus";
        var languageTargetOptions ;
        var languageTargetOptions;
        var SpeechSDK = window.SpeechSDK;
        var recognizer;
        var resultsDivs;
        startRecognizeOnceAsyncButton = document.getElementById("startRecognizeOnceAsyncButton");
        this.isListening = !this.isListening;

        var thi = this;

          languageTargetOptions = [
           "zh-Hans","en"
         ];

            var speechConfig = SpeechSDK.SpeechTranslationConfig.fromSubscription(subscriptionKey, serviceRegion);

            speechConfig.speechRecognitionLanguage = "zh-CN";
            let languageKeys = {};
            languageTargetOptions.forEach(function(langElem, index){
                speechConfig.addTargetLanguage(langElem)

            });

            var audioConfig  = SpeechSDK.AudioConfig.fromDefaultMicrophoneInput();

            recognizer = new SpeechSDK.TranslationRecognizer(speechConfig, audioConfig);


            recognizer.recognizeOnceAsync(
                function (result) {
                    console.log(result)
                    console.log(result.privText)
                    if (result.privText == undefined || result.privText == "undefined" || result.privText == "") {
                        console.log("语音失败暂时不能使用")

                    } else {
                        console.log(result.privText)
                        thi.isListening = !thi.isListening;
                        thi.input3 = result.privText;
                        startRecognizeOnceAsyncButton.disabled = false;

                        recognizer.close();
                        recognizer = undefined;

                    }

                },
                function (err) {
                    console.log(err)
                    thi.isListening = !thi.isListening;
                    startRecognizeOnceAsyncButton.disabled = false;
                    thi.input3 = "没有识别成功，请换其他方式提问！";
                    window.console.log(err);

                    recognizer.close();
                    recognizer = undefined;
                });

    },
    visible11() {
      this.visible1 = true;
      this.$nextTick(() => {
        this.$refs.serachBox.focus();
      });
    },
    async handleMsg() {
      this.$refs.video.pause();//暂停
      var timestamps = '';

      var thi = this;
      var coursename = this.resource.chapter_title;
      if (this.input3.length>1 ) {
        if (this.input3.length>=100) {
          Message.error("亲，字数太多了，我聪明的大脑读取不了！");
        } else {
          if (this.timestamp == '') {
            Message.error("亲，请在视频播放时提问哦！");
          } else {
            timestamps = '['+this.timestamp+']';
            this.loading = true;
            await this.list.push({ align: "right", text: this.input3 ,timestamp: this.timestamp});
            var chatGPT={
              coursename: coursename,
              timestamp: timestamps,
              chat_history:thi.input3,
              stream_output:false,
              tts: false
            }
console.log(thi.word)
              if (thi.word != '' )  {
                  this.gptlist.push(thi.word);
              }
              this.gptlist.push(thi.input3)
             var cc = JSON.stringify(thi.gptlist);

              var sendGptchatGPT={
                  coursename: coursename,
                  timestamp: timestamps,
                  chat_history:thi.gptlist,
                  stream_output:false,
                  tts: false
              }
            await this.scrollTop11();
            this.input3 = "";

            if (this.list.length >= 200) {
              Message.error("亲，提问太多(超100次)，消化不了！请联系客服");
            } else {
                console.log(sendGptchatGPT)
               let res =  await this.sendGpt(sendGptchatGPT);
               await  this.saveGptMsg(res,chatGPT);
            }
          }

        }

      } else {
        Message.error("请多写几个字哟！");
      }

    },
      //从后台获取返回的gpt
    async sendGpt(chatGPT){
      const {data: res} = await this.$http.post(`chatgpt/responseList`,chatGPT)
      this.loading = false;
      return res;
    },
      //存储数据
    async saveGptMsg(response,chatGPT) {
      var thi = this;
      // 处理自己的接口请求 返回需要的数据
        console.log(response);

        if (response.code == 1) {
          // 自行处理需要的数据
          var gpt = {};
          var chapterId = thi.chapter_id;
          var courseId = thi.course_id;
          var userId = thi.uid;
          var chatgpt = response.data.text;
          var time = chatGPT.timestamp;
          var history = chatGPT.chat_history;
          console.log(time)
          thi.saveGPT(chapterId, courseId, userId, chatgpt, time, history)
          const msg = response.data.text;
          let listMsg = {
            align: "left",
            text: msg,
            link: "",
          };
          await thi.list.push(listMsg);
          await thi.scrollTop11();
            thi.word = msg
        }else {
          const msg = "请稍后再试！或者联系客服";
          let listMsg = {
            align: "left",
            text: msg,
            link: "",
          };
          await thi.list.push(listMsg);
          await thi.scrollTop11();
            Message.error("请稍后再试！或者联系客服！");
            thi.word = msg;
        }
        thi.loading = false;
    },
    // 处理滚动条一直保持最上方
    scrollTop11() {
      let div = document.getElementById("bigBox");
      div.scrollTop = div.scrollHeight + 50;
    },
    //保存到数据库
    async saveGPT(chapterId, courseId, userId, chatgpt, time, history){
      let saveDialogue = {
        chapterId: chapterId,
        courseId: courseId,
        userId:userId,
        chatgpt:chatgpt,
        time:time,
        history:history
      }
      const {data: res} = await this.$http.post(`chatgpt/saveDialogue`,saveDialogue)
      console.log(res)

    },
    //处理Enter键的逻辑
      handleEnterKey() {
          // 处理Enter键的逻辑
          console.log('处理Enter键的逻辑11')
          this.handleMsg(); //调用方法
      },

    //h获取chatGPT
    async getChatGPT(){
      var thi = this;
      var chapter_id = thi.chapter_id;
      var course_id = thi.course_id;
      var userId = thi.uid;
      const {data: res} = await thi.$http.get(`/courses/${course_id}/chapter/${chapter_id}/userId/${userId}`)
      // this.resource = res.data
      console.log(res.data)
      for (var i=0;i<res.data.length;i++)
      {

        let listMsg = {
          align: "right",
          timestamp:res.data[i].time.substr(11,8),
          text: res.data[i].history,
          link: "",
        };
        await thi.list.push(listMsg);
        let listMsgl = {
          align: "left",
          text: res.data[i].chatgpt,
          link: "",
        };
        await thi.list.push(listMsgl);
      }
    },
    //时分秒转换
    getHMS(time) {
      const hour = parseInt(time / 3600) < 10 ? '0' + parseInt(time / 3600) : parseInt(time / 3600)
      const min = parseInt(time % 3600 / 60) < 10 ? '0' + parseInt(time % 3600 / 60) : parseInt(time % 3600 / 60)
      const sec = parseInt(time % 3600 % 60) < 10 ? '0' + parseInt(time % 3600 % 60) : parseInt(time % 3600 % 60)
      return hour + ':' + min + ':' + sec
    },

    //获取视频的总时长
    getDuration() {
      let s = this.$refs.video.duration;
      console.log(s+'=========获取视频的总时长')
    },
    //获取当前播放时间
    updateTime() {
      let s=this.$refs.video.currentTime;

      this.timestamp = this.getHMS(s)
      console.log(this.timestamp+'=======获取当前播放时间')
    },
    //播放器停止播放
    closeVideo(){
      this.$refs.video.muted = false;
      console.log(this.$refs.video)
    },
    //播放器设置时长，到指定播放位置
    setTime(){
      this.$refs.video.currentTime = 3.2;
    },
    // 根据章节id获取视频资源
    async getCourseSrc(course_id, chapter_id) {
      const {data: res} = await this.$http.get(`/courses/${course_id}/chapter/${chapter_id}`)
      this.resource = res.data
    },

    // 跳转其他章节
    getVideo(course_id, chapter_id) {
      this.$router.push(`/courses/${course_id}/chapter/${chapter_id}`)
      location.reload()
    },

    //  根据课程id查询章节列表
    async getChapterList(course_id) {
      const {data: res} = await this.$http.get(`/courses/chapter/${course_id}`)
      this.chapterList = res.data;
    },

    openNote() {
      this.visible = true
    },

    // 推荐课程
    async getHotCourses() {
      const {data: res} = await this.$http.get('/courses/hot')
      this.hotCourse = res.data;
    },


//开始录音
    startRecordAudio() {
      Recorder.getPermission().then(
          () => {
            console.log("开始录音");
            this.updateTime();
            this.$refs.video.pause();//暂停
            this.recorder.start(); // 开始录音
            console.log(this.recorder)
          },
          (error) => {

             Message.error("请先允许该网页使用麦克风！");

            console.log(`${error.name} : ${error.message}`);
          }
      );
    },
    //停止录音
    stopRecordAudio() {
      console.log("停止录音");
      this.recorder.stop();
      var formData = new FormData()
      console.log('时长',this.recorder.duration)
      var wavBlob = this.recorder.getWAVBlob();
      console.log(wavBlob)
        var code = 'ca5e53cbad144a64afcf6ba21f33a2c3';
        var en = btoa(code);
        console.log(en)
        var de = unescape(en);
         console.log(de)

        // 此处获取到blob对象后需要设置fileName满足当前项目上传需求，其它项目可直接传把blob作为file塞入formData
      const newbolb = new Blob([wavBlob], { type: 'audio/wav' })
      var audioFile = new Blob([wavBlob], { type: 'audio/mp3' });
      console.log('audioFile,mp3'+audioFile)
      //获取当时时间戳作为文件名
      const fileOfBlob = new File([newbolb], new Date().getTime() + '.wav')
      console.log(fileOfBlob)
      const url = window.URL.createObjectURL(fileOfBlob)
      this.src = url
      console.log(url)
      formData.append('file', fileOfBlob)
      console.log(formData)
        this.fromFile("https://crbn.us/whatstheweatherlike.wav")

    },
    //播放录音
    playRecordAudio() {
      console.log("播放录音");
      console.log(this.recorder)
      this.recorder.play();
      this.setTime();

    },
    fromFile(filename){
        const fs = require("fs");
       // let audioConfig = sdk.AudioConfig.fromWavFileInput(fs.readFileSync(filename));
        let speechRecognizer = new sdk.SpeechRecognizer(speechConfig, filename);

        speechRecognizer.recognizeOnceAsync(result => {
            switch (result.reason) {
                case sdk.ResultReason.RecognizedSpeech:
                    console.log(`RECOGNIZED: Text=${result.text}`);
                    break;
                case sdk.ResultReason.NoMatch:
                    console.log("NOMATCH: Speech could not be recognized.");
                    break;
                case sdk.ResultReason.Canceled:
                    const cancellation = sdk.CancellationDetails.fromResult(result);
                    console.log(`CANCELED: Reason=${cancellation.reason}`);

                    if (cancellation.reason == sdk.CancellationReason.Error) {
                        console.log(`CANCELED: ErrorCode=${cancellation.ErrorCode}`);
                        console.log(`CANCELED: ErrorDetails=${cancellation.errorDetails}`);
                        console.log("CANCELED: Did you set the speech resource key and region values?");
                    }
                    break;
            }
            speechRecognizer.close();
        });
    },

  }
}
</script>

<style scoped>
*{ margin:0; padding:0; }
ul li{
  list-style-type:none;
}
.mc{
  float: left;
  margin-left: 12%;
}
.biao a:hover{
  color: #FFAE00;
  cursor: pointer;
}
.duih{
  float: left;
  font-family: PingFang SC;
  color: #FFAE00;
  padding-bottom: 10px;
  display: block;
  border-bottom: 1px solid;
}

.zaix{
  float: right;color: #333333;

}
.chat li {
  min-height: 50px;
  font-size: 14px;
}
/*奇数行*/
.chat li:nth-of-type(odd){ margin-left: 5px;
  text-align: left;
  width: 80%;
  margin-top: 15px;
}
/*偶数行*/
.chat li:nth-of-type(even){margin-left: 5px;
  text-align: right;
}

.chatrg a{
  color: #FFAE00;
}
.huid a {
  color: #FFAE00;
}
.chatlf img {
  width: 40px;
  border-radius: 50%;
  float: left;
}
.shij{
  font-size: 14px;
  font-family: PingFang SC;
  line-height: 27px;
  margin-left: 20px;
}
.huid{
  margin-left: 10px;
  margin-top: 20px;
  line-height: 35px;
  height: 35px;
}
/deep/ .el-input-group__append{
  background-color: rgb(255, 174, 0)!important;
}
el-input {
  border: none;
  padding-right: 10px;
}

.el-button {
    color:#fff;
    padding: 12px 10px!important;;
}
/deep/ .el-textarea__inner {
    height: 40px!important;
}
</style>
